import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import ReactDOM from 'react-dom';

import CompaniesItem from './companes-item';
import SearchBox from '../search-box';
import CustomSelect from '../select';
import NoResults from '../no-results';

import Api from '../../../lib/seam-api';
import {fireEnquireOpenEvent} from "../../overlay/enquire";

class Companies extends Component {
    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            currentCompanies: [],
            industries: [],

            selectedType: '',
            direction: null,
            search: '',
            page: 1,
            pageCount: 0,
            itemOffset: 0,
            itemsPerPage: 12,
            totalCompanies: 0,
        }

        this.timer = null;
    }

    componentDidMount() {
        this.fetchDefault();
        this.fetchTypes();
    }

    setCompaniesPaginated() {
    }

    handlePageClick = (event) => {
        this.setState({page: event.selected + 1}, () => this.fetchDefault());
    }

    async fetchDefault() {
        const {data, meta: {last_page}} = await Api.companies().get({
            page: this.state.page,
            perPage: this.state.itemsPerPage,
            industryTypes: this.state.selectedType ? [this.state.selectedType] : [],
            direction: this.state.direction || null,
            orderBy: 'name'
        });

        this.setState({companies: data, pageCount: last_page});
    }

    async fetchTypes() {
        const {data} = await Api.companies().industries();

        this.setState({industries: data})
    }

    async search() {
        if (this.state.search.length == 0) return;

        if (this.timer) {
            clearTimeout(this.timer);
        }

        this.searchAll();
    }

    async searchTypes() {
        if (this.state.search.length == 0) return this.fetchDefault();

        this.searchAll();
    }

    async searchAll() {
        const {data} = await Api.companies().search({
            term: this.state.search,
            page: this.state.pageCount,
            perPage: this.state.itemsPerPage,
            industryTypes: this.state.selectedType ? [this.state.selectedType] : [],
            direction: this.state.direction,
            orderBy: 'name'
        });

        this.setState({companies: data, pageCount: 0});
    }

    typesOnChange(event) {
        this.setState({
            selectedType: Number(event.value),
        }, () => {
            this.searchTypes();
        });
    }

    sortOnChange(event) {
        this.setState({
            direction: event.value,
        }, () => {
            this.searchTypes();
        });
    }

    onChangeHandler({target: {value}}) {
        this.setState({
            search: value,
        }, () => {
            this.changed();
        });
    }

    changed() {
        if (this.state.search.length > 0) {
            return this.search();
        }

        this.fetchDefault();
    }

    render() {
        return (
            <>
                <div className="index__topbar">
                    <SearchBox search={this.state.search} onChangeHandler={this.onChangeHandler.bind(this)}/>

                    <div className="utils__row index-topbar__wrap">
                        <CustomSelect placeholder="Filter by industry" onChange={this.typesOnChange.bind(this)}
                                      items={this.state.industries.map(({id, name}) => ({option: name, value: id}))}/>

                        <CustomSelect placeholder="Sort results by" onChange={this.sortOnChange.bind(this)} items={[
                            {
                                option: 'Alphabetical (A-Z)',
                                value: 'asc'
                            },
                            {
                                option: 'Alphabetical (Z-A)',
                                value: 'desc'
                            },
                        ]}/>
                    </div>
                </div>

                {this.state.companies.length > 0 ? <>
                    <div className="index__items">
                        {this.state.companies.map((data, index) => <CompaniesItem key={index} data={data}
                                                                                  cdn={this.props.cdn}
                                                                                  industry={this.state.industries.find(i => i.id == data.company_industry_id)}/>)}
                    </div>

                    <ReactPaginate
                        breakLabel="..."
                        onPageChange={this.handlePageClick.bind(this)}
                        pageRangeDisplayed={5}
                        pageCount={this.state.pageCount}
                        nextLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Next Arrow'/>}
                        previousLabel={<img src='/images/blocks/gallery/arrow.svg' alt='Previous Arrow'/>}
                        renderOnZeroPageCount={null}
                        containerClassName="event-index__pagination"
                    />
                </> : <NoResults
                    title={'NO COMPANIES FOUND'}
                    subtitle={'Please can you refine your result or try searching manually.'}
                    content={`Need help finding what you're looking for?`}
                    onClick={e => {
                        e.preventDefault();
                        fireEnquireOpenEvent(0)
                    }}
                />
                }
            </>
        )
        }
}

export default Companies;

document.addEventListener('readystatechange', () => {
    const element = document.getElementById('companies-index')

    if (element) {
        const cdn = element.getAttribute('data-cdn');
        ReactDOM.render(<Companies cdn={cdn}/>, element);
    }
});
